const getFirstValidationIssue = (errorData) => errorData?.errors
  ?.find((validationError) => validationError?.issue)
  ?.issue;

const getMessageText = (message) => {
  if (!message) return null;
  if (typeof message === 'string') return message;

  return message.content || message.message || null;
};

export const getWebhookApiErrorMessage = (error, fallbackMessage) => {
  const errorData = error?.response?.data;
  const validationIssue = getFirstValidationIssue(errorData);

  return validationIssue || getMessageText(errorData?.error?.message) || fallbackMessage;
};

export const isValidWebhookEndpointUrl = (value) => {
  if (!value) return false;

  try {
    const url = new URL(value);
    return ['http:', 'https:'].includes(url.protocol) && Boolean(url.hostname);
  } catch {
    return false;
  }
};
